import axios from 'axios';

export class FileService {

    uploadFilePositionFideicomiso(file) {
        let formData = new FormData();
        formData.append("file", file);
        return axios.post('/appapv/uploadFilePositionFideicomiso.action', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace la petición al back para guardar cualquier documento.
     * @param file Documento que se va a guardar.
     * @param urlAction Url del back donde se encuentra la función que se va a ejecutar.
     * @param props Parámetros, si es que se necesitan en la petición.
     * @returns {Promise<unknown>}
     */
    uploadFile(file, urlAction, props) {
        let formData = new FormData();
        formData.append("file", file);
        return axios.post(urlAction, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            params: props,
        }).then(res => res.data);
    }
}